<div class="list-status">
  <div class="list-status__item" *ngFor="let item of listStatus"
  [ngClass]="setClassStatus(item)"
  [attr.aria-label]="setAriaLabel(item)" role="text">
    <span class="list-status__icon" aria-hidden="true">
      <img [src]="item.icon" alt="icon">
    </span>
    <span class="list-status__step" aria-hidden="true">{{item.step}}</span>
    <span class="list-status__status" aria-hidden="true">{{item.status}}</span>
  </div>
</div>
